import { apiAxios } from "./apiConfig";

/* ---------- Types ---------- */

export interface QuestionOption {
  id: string;
  optionName: string;
  isActive: boolean;
  optionOrder: number;
}

export interface QuestionCategory {
  id: string;
  name: string;
  isActive: boolean;
}

export interface QuestionUpdater {
  id: string;
  name: string;
}

export interface QuestionCreator {
  id: string;
  name: string;
}
export interface Question {
  id: string;
  questionName: string;
  isActive: boolean;
  questionCategoryId: string;
  createdAt: string;
  updatedAt: string;
  questionCategory: QuestionCategory;
  options: QuestionOption[];
  updater: QuestionUpdater;
  creator: QuestionCreator;
}

export interface QuestionListResponse {
  status: boolean;
  data: Question[];
}

/* ---------- API Function ---------- */

export const getQuestionList = async (): Promise<QuestionListResponse> => {
  const response = await apiAxios.get<QuestionListResponse>("/question/list");
  return response.data;
};

export interface QuestionOptionPayload {
  optionName: string;
  optionOrder: number;
}

export interface CreateQuestionPayload {
  questionName: string;
  questionDescription: string;
  questionCategoryId: string;
  options: QuestionOptionPayload[];
}

export interface UpdateQuestionPayload extends CreateQuestionPayload {
  isActive: boolean;
}

export interface QuestionResponse {
  status: boolean;
  data: any;
}

/* ---------- APIs ---------- */

export const createQuestion = async (
  payload: CreateQuestionPayload,
): Promise<QuestionResponse> => {
  const response = await apiAxios.post<QuestionResponse>(
    "/question/create",
    payload,
  );
  return response.data;
};

export const updateQuestion = async (
  id: string,
  payload: UpdateQuestionPayload,
): Promise<QuestionResponse> => {
  const response = await apiAxios.put<QuestionResponse>(
    `/question/${id}`,
    payload,
  );
  return response.data;
};

export interface QuestionCategory {
  id: string;
  name: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface QuestionCategoryListResponse {
  status: boolean;
  data: QuestionCategory[];
}

export const getQuestionCategoryList =
  async (): Promise<QuestionCategoryListResponse> => {
    const response = await apiAxios.get<QuestionCategoryListResponse>(
      "/question-category/list",
    );
    return response.data;
  };
